export * from './delete-standort.service';
export * from './delete-standort.service.module';